module.exports = __webpack_public_path__ + "static/img/example02.e8a3b5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/school/schoolmember/example02.png
// module id = Zd1B
// module chunks = 1